var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.06494 9.11084H6.896V13.9419C6.896 14.5479 7.39404 15.0459 8 15.0459C8.60596 15.0459 9.104 14.5479 9.104 13.9419V9.11084H13.9351C14.541 9.11084 15.0391 8.62109 15.0391 8.00684C15.0391 7.40088 14.541 6.90283 13.9351 6.90283H9.104V2.07178C9.104 1.46582 8.60596 0.967773 8 0.967773C7.39404 0.967773 6.896 1.46582 6.896 2.07178V6.90283H2.06494C1.45898 6.90283 0.960938 7.40088 0.960938 8.00684C0.960938 8.62109 1.45898 9.11084 2.06494 9.11084Z",
    fill: "#232326"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.471448abfba30c79a99b51c71d36b32e.svg";
export { ForwardRef as ReactComponent };